// src/routes.jsx
// ✅ النسخة المحدَّثة — تشمل بوابة الزبون (/client-login, /my-bookings)

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './features/auth/context/AuthContext';

// ── الصفحات الرئيسية ──────────────────────────────────────
import BookingList               from './features/bookings/components/BookingList';
import BookingDetail             from './features/bookings/components/BookingDetail';
import KanbanBoard               from './features/tasks/components/KanbanBoard';
import ClientManagement          from './features/clients/components/ClientManagement';
import UserManagement            from './features/users/components/UserManagement';
import Settings                  from './features/settings/components/Settings';
import Login                     from './features/auth/components/Login';
import Reports                   from './features/reports/components/Reports';
import ExpenseManagement         from './features/expenses/components/ExpenseManagement';
import ExpenseCategoryManagement from './features/expenses/components/ExpenseCategoryManagement';
import ClientReport              from './features/client-report/components/ClientReport';
import TreasuryDashboard         from './features/treasury/components/TreasuryDashboard';

// ── بوابة الزبون ──────────────────────────────────────────
import ClientLogin     from './features/client-portal/components/ClientLogin';
import ClientDashboard from './features/client-portal/components/ClientDashboard';

// ── سجل النشاط ────────────────────────────────────────────
import ActivityLogPage from './features/activity/components/ActivityLog';

// ── بحث ضيوف PhotoFace (صفحة عامة يفتحها رمز QR) ─────────
import GuestSearch from './features/photoface/components/GuestSearch';


import Documents from './features/documents/components/Documents';



// ─────────────────────────────────────────────────────────────
// مكوّنات الحماية
// ─────────────────────────────────────────────────────────────

/** يحمي أي صفحة تتطلب تسجيل الدخول */
const ProtectedRoute = ({ children }) => {
  const { loggedInUser } = useAuth();
  return loggedInUser ? children : <Navigate to="/login" replace />;
};

/** يحمي الصفحات حسب القسم المسموح به */
const RoleRoute = ({ children, section }) => {
  const { canAccess } = useAuth();
  return canAccess(section) ? children : <Navigate to="/" replace />;
};

/** صفحة للزبون فقط */
const ClientRoute = ({ children }) => {
  const { loggedInUser } = useAuth();
  if (!loggedInUser)                return <Navigate to="/client-login" replace />;
  if (!loggedInUser.is_client)      return <Navigate to="/"             replace />;
  return children;
};

/** صفحة تسجيل دخول الزبون — تُعيد التوجيه إذا كان مسجلاً */
const ClientLoginRoute = ({ children }) => {
  const { loggedInUser } = useAuth();
  if (loggedInUser?.is_client)  return <Navigate to="/my-bookings" replace />;
  if (loggedInUser)             return <Navigate to="/"            replace />;
  return children;
};

// ─────────────────────────────────────────────────────────────
// المسارات
// ─────────────────────────────────────────────────────────────
const AppRoutes = () => {
  const { loggedInUser, canAccess } = useAuth();

  return (
    <Routes>

      {/* ── تسجيل دخول الموظفين/المدراء ── */}
      <Route
        path="/login"
        element={
          loggedInUser && !loggedInUser.is_client
            ? <Navigate to="/" replace />
            : <Login />
        }
      />

      {/* ── تسجيل دخول الزبون ── */}
      <Route
        path="/client-login"
        element={
          <ClientLoginRoute>
            <ClientLogin />
          </ClientLoginRoute>
        }
      />

      {/* ── الصفحة الرئيسية — حسب الدور ── */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {loggedInUser?.is_client
              ? <Navigate to="/my-bookings" replace />
              : canAccess('bookings')
                ? <BookingList />
                : <KanbanBoard />
            }
          </ProtectedRoute>
        }
      />

      {/* ── بوابة الزبون ── */}
      <Route
        path="/my-bookings"
        element={
          <ClientRoute>
            <ClientDashboard />
          </ClientRoute>
        }
      />

      {/* ── صفحات الموظف/المدير ── */}
      <Route path="/booking/:id"        element={<ProtectedRoute><BookingDetail /></ProtectedRoute>} />
      <Route path="/tasks"              element={<RoleRoute section="tasks"><KanbanBoard /></RoleRoute>} />
      <Route path="/reports"            element={<RoleRoute section="reports"><Reports /></RoleRoute>} />
      <Route path="/expenses"           element={<RoleRoute section="expenses"><ExpenseManagement /></RoleRoute>} />
      <Route path="/expense-categories" element={<RoleRoute section="expense_categories"><ExpenseCategoryManagement /></RoleRoute>} />
      <Route path="/client-report"      element={<RoleRoute section="client_report"><ClientReport /></RoleRoute>} />
      <Route path="/treasury"           element={<RoleRoute section="treasury"><TreasuryDashboard /></RoleRoute>} />
      <Route path="/clients"            element={<RoleRoute section="clients"><ClientManagement /></RoleRoute>} />
      <Route path="/users"              element={<RoleRoute section="users"><UserManagement /></RoleRoute>} />
      <Route path="/activity-log"       element={<RoleRoute section="activity_log"><ActivityLogPage /></RoleRoute>} />
      <Route path="/settings"           element={<RoleRoute section="settings"><Settings /></RoleRoute>} />
<Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />

      {/* ── بحث ضيوف PhotoFace — صفحة عامة بلا تسجيل دخول ── */}
      <Route path="/search/:albumId" element={<GuestSearch />} />

      {/* ── fallback ── */}
      <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  );
};

export default AppRoutes;